module.exports = __webpack_public_path__ + "static/media/ifcjclogo.82cf2771.jfif";